import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/retina/welcome3@2x.png")